/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import { ID } from '@gh/common-shared-data';
import { AbstractRestService, arrayOf, RestSettings } from '@gh/core-data';

import { Observable } from 'rxjs';
import { LeadBoardFilter, LeadBoardListItemDto, LeadBoardListItemParams } from './lead-board.dto';

import { LeadBoardItemMapper, LeadBoardParamsMapper } from './lead-board.mapper';

@Injectable()
export class LeadBoardRestService extends AbstractRestService {
  constructor(settings: RestSettings) {
    super(settings);
  }

  findAll(salesPersonId: Maybe<ID>,
          { showCompleted,
            showActive,
            showInactive,
            showOverdue,
            showSuppressed,
            searchString,
          }: LeadBoardFilter): Observable<LeadBoardListItemDto[]> {
    return this.httpGet(
      `${this.crm}/leads/sales-folders`,
      {
        salesPersonId,
        showCompleted,
        showActive,
        showInactive,
        showOverdue,
        showSuppressed,
        searchString,
      },
      void 0,
      arrayOf(LeadBoardItemMapper));
  }

  update(id: ID, params: LeadBoardListItemParams): Observable<LeadBoardListItemParams> {
    return this.httpPut(`${this.bp}/leads/sales-folders/${id}`, params, LeadBoardParamsMapper);
  }
}
